import { render, staticRenderFns } from "./RyuryoChart.vue?vue&type=template&id=3c92f29a&scoped=true"
import script from "./RyuryoChart.vue?vue&type=script&lang=ts"
export * from "./RyuryoChart.vue?vue&type=script&lang=ts"
import style0 from "./RyuryoChart.vue?vue&type=style&index=0&id=3c92f29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c92f29a",
  null
  
)

export default component.exports